/**
 * vendor-alternates-resolver — implemented by Sprint 11 (Ingredient
 * Sourcing). Stub originally reserved by Sprint 03 D-6 for "Sprint
 * 05/06" (since reconciled to Sprint 11 + Sprint 12). See README.md.
 *
 * Resolver hits `GET /api/sourcing/alternates/{productId}` and
 * returns the typed `VendorAlternate[]` shape. Server-side ranking
 * (approved-first → cheapest → shortest lead) is applied before
 * the response leaves the middleware; consumers just render in
 * order.
 *
 * Nullable fields: the original Sprint 03 stub typed everything
 * non-null, but the real Odoo data has gaps. `fixed_price`,
 * `min_quantity`, `lead_time_days`, `on_hand_qty`, and
 * `last_po_date` are all nullable on the wire.
 */

import { jsonFetch } from '@/lib/api/jsonFetch'

export interface VendorAlternate {
  partner_id: number
  partner_name: string
  fixed_price: number | null
  min_quantity: number | null
  lead_time_days: number | null
  on_hand_qty: number | null
  approved: boolean
  last_po_date: string | null
}

interface AlternatesResponse {
  alternates: VendorAlternate[]
}

export async function resolveAlternates(
  productId: number,
): Promise<VendorAlternate[]> {
  const res = await jsonFetch<AlternatesResponse>(
    `/api/sourcing/alternates/${productId}`,
  )
  return res.alternates ?? []
}
